export const auth = {
  login: "Connexion",
  logout: "Êtes-vous certain de vouloir vous déconnecter?",
  form: {
    password: {
      label: "Mot de passe",
      errors: {
        empty: "Veuillez saisir votre mot de passe.",
      },
    },
    newPassword: {
      label: "Nouveau mot de passe",
      errors: {
        empty: "Veuillez saisir votre nouveau mot de passe.",
        min: "Le mot de passe doit contenir au moins 8 caractères.",
        lowercaseLetter:
          "Le mot de passe doit contenir au moins une lettre minuscule.",
        uppercaseLetter:
          "Le mot de passe doit contenir au moins une lettre majuscule.",
        number: "Le mot de passe doit contenir au moins un chiffre.",
        specialCharacter:
          "Le mot de passe doit contenir au moins un caractère spécial.",
      },
    },
    confirmPassword: {
      label: "Confirmer le nouveau mot de passe",
      errors: {
        empty: "Veuillez confirmer votre nouveau mot de passe.",
        dontMatch: "Le mot de passe et la confirmation ne correspondent pas.",
      },
    },
  },
};
